import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { logEvent } from 'config/tracking';
import { TrackingEventName } from 'utils/types/amplitude';
import { SFormError, SSuccess } from './styles';
import useSignUpRequest, { SignUpInputs } from './useSignUpRequest';

type ResendActivationMailProps = {
    inputs: SignUpInputs;
};

/**
 * Renvoyer l'email, c'est refaire la même demande d'inscription : le serveur renvoie le lien d'un
 * compte jamais activé, et ne crée rien. La limite par adresse s'applique donc aussi aux renvois.
 */
const ResendActivationMail: FC<ResendActivationMailProps> = ({ inputs }) => {
    const { t } = useTranslation();
    const { captcha, failure, send } = useSignUpRequest();
    const [isSending, setIsSending] = useState(false);
    const [resentCount, setResentCount] = useState(0);

    const resend = async () => {
        setIsSending(true);
        const resendFailure = await send(inputs);
        setIsSending(false);

        if (!resendFailure) {
            logEvent({ name: TrackingEventName.ACTIVATION_MAIL_RESENT, params: {} });
            setResentCount((count) => count + 1);
        }
    };

    return (
        <>
            {captcha}
            {failure && (
                <SFormError role="alert">
                    {t(`sign-up-form.errors.${'invalid-email' === failure ? 'unavailable' : failure}`)}
                </SFormError>
            )}
            {!failure && resentCount > 0 && (
                // La clé change à chaque renvoi : le message est relu par les lecteurs d'écran.
                <SSuccess key={resentCount} role="status">
                    {t('page.sign-up.confirmation.resent')}
                </SSuccess>
            )}
            <Button disabled={isSending} onClick={resend} variant="outlined" large>
                {t('page.sign-up.confirmation.resend')}
            </Button>
        </>
    );
};

export default ResendActivationMail;
